"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOutstandingInvoiceDto = instanceOfOutstandingInvoiceDto;
exports.OutstandingInvoiceDtoFromJSON = OutstandingInvoiceDtoFromJSON;
exports.OutstandingInvoiceDtoFromJSONTyped = OutstandingInvoiceDtoFromJSONTyped;
exports.OutstandingInvoiceDtoToJSON = OutstandingInvoiceDtoToJSON;
exports.OutstandingInvoiceDtoToJSONTyped = OutstandingInvoiceDtoToJSONTyped;
/**
 * Check if a given object implements the OutstandingInvoiceDto interface.
 */
function instanceOfOutstandingInvoiceDto(value) {
    if (!('facilityName' in value) || value['facilityName'] === undefined)
        return false;
    if (!('stripeInvoiceId' in value) || value['stripeInvoiceId'] === undefined)
        return false;
    if (!('stripeDashboardUrl' in value) || value['stripeDashboardUrl'] === undefined)
        return false;
    if (!('number' in value) || value['number'] === undefined)
        return false;
    if (!('totalCents' in value) || value['totalCents'] === undefined)
        return false;
    if (!('amountRemainingCents' in value) || value['amountRemainingCents'] === undefined)
        return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined)
        return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined)
        return false;
    return true;
}
function OutstandingInvoiceDtoFromJSON(json) {
    return OutstandingInvoiceDtoFromJSONTyped(json, false);
}
function OutstandingInvoiceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'facilityName': json['facilityName'],
        'stripeInvoiceId': json['stripeInvoiceId'],
        'stripeDashboardUrl': json['stripeDashboardUrl'],
        'number': json['number'],
        'totalCents': json['totalCents'],
        'amountRemainingCents': json['amountRemainingCents'],
        'invoiceDate': (new Date(json['invoiceDate'])),
        'dueDate': (json['dueDate'] == null ? null : new Date(json['dueDate'])),
    };
}
function OutstandingInvoiceDtoToJSON(json) {
    return OutstandingInvoiceDtoToJSONTyped(json, false);
}
function OutstandingInvoiceDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'facilityName': value['facilityName'],
        'stripeInvoiceId': value['stripeInvoiceId'],
        'stripeDashboardUrl': value['stripeDashboardUrl'],
        'number': value['number'],
        'totalCents': value['totalCents'],
        'amountRemainingCents': value['amountRemainingCents'],
        'invoiceDate': ((value['invoiceDate']).toISOString()),
        'dueDate': (value['dueDate'] == null ? null : value['dueDate'].toISOString()),
    };
}
//# sourceMappingURL=OutstandingInvoiceDto.js.map